import { Static } from '@sinclair/typebox';
import { ListResponseSchema } from '../../shared/utils/list-response.schema';
import { ContactSchema } from './contacts.schema';

export const ContactsListResponseSchema = ListResponseSchema(ContactSchema);

export type ContactsListResponse = Static<typeof ContactsListResponseSchema>;
